import { defineMessages } from 'react-intl';

const messages = defineMessages({
  about_evarfinance: {
    id: 'mobile_nav.about_evarfinance',
    defaultMessage: 'About Evarfinance',
  },
  our_offering: {
    id: 'mobile_nav.our_offering',
    defaultMessage: 'Our Offering',
  },
  contact_us: {
    id: 'mobile_nav.contact_us',
    defaultMessage: 'Contact Us',
  },
  get_started: {
    id: 'mobile_nav.get_started',
    defaultMessage: 'GET STARTED',
  },
});

export default messages;
